import { TestExecutionField } from '@elementary/common-ui/services/gql/types';

export const COLUMN_TO_FIELD_MAP: Record<string, TestExecutionField> = {
  'metadata.latest_run_status': 'STATUS',
  last_exec_time: 'EXECUTION_DURATION',
  'metadata.latest_run_time': 'EXECUTION_TIME',
  'metadata.test_name': 'TEST_NAME',
  'metadata.test_sub_type': 'SUB_TYPE',
  'metadata.table_name': 'ASSET_TABLE_NAME',
  'metadata.column_name': 'COLUMN_NAME',
  'metadata.test_tags': 'TEST_TAG',
  'metadata.database_name': 'ASSET_DATABASE_NAME',
  'metadata.schema_name': 'ASSET_SCHEMA_NAME',
  'asset_metadata.tags': 'ASSET_TAG',
  'asset_metadata.owners': 'ASSET_OWNER',
  'asset_metadata.subscribers': 'ASSET_SUBSCRIBER',
  'asset_metadata.name': 'ASSET_NAME',
  'asset_metadata.path': 'ASSET_PATH',
  'asset_metadata.is_critical': 'ASSET_IS_CRITICAL',
};

export const FIELD_TO_COLUMN_MAP: Partial<Record<TestExecutionField, string>> =
  Object.fromEntries(
    Object.entries(COLUMN_TO_FIELD_MAP).map(([column, field]) => [
      field,
      column,
    ]),
  );
